export default __webpack_public_path__ + "static/media/ball.ddfc1a1f.png";